// src/redux/reducer.js
import {
  INIT_ALERT_LIST_REQUEST,
  SET_ALERT_LIST,
  APPEND_ALERT_LIST,
  ERROR_ALERT_LIST,
  DELETE_ALERT,
  ERROR_ALERT_REQUEST
} from './action';

const initialState = {
  alerts: [],
  loading: false,
  error: '',
  page: 1,
  total: 0,
  totalPage: 1,
  pageSize: 10,
};

const alertNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_ALERT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: ''
      };
    case SET_ALERT_LIST:
      return {
        ...state,
        loading: false,
        alerts: action.payload.data,
        page: action.payload.page,
        total: action.payload.total,
        totalPage: action.payload.totalPage,
        pageSize: action.payload.pageSize,
        error: ''
      };
    case APPEND_ALERT_LIST:
      return {
        ...state,
        loading: false,
        alerts: [...state.alerts, ...action.payload.data],
        page: action.payload.page,
        total: action.payload.total,
        totalPage: action.payload.totalPage,
        pageSize: action.payload.pageSize,
        error: ''
      };
    case ERROR_ALERT_LIST:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case DELETE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter(alert => alert.id !== action.payload),
        error: ''
      };
    case ERROR_ALERT_REQUEST:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export default alertNotificationReducer;
